import { IconNames } from "@blueprintjs/icons";
import React from "react";

import { FormGroup } from "@blueprintjs/core";
import autobind from "autobind-decorator";
import IOption from "common/models/IOption";
import { iDef } from "core/util/TypeUtils";
import BaseWidget from './BaseWidget';
import ButtonSelect from "./common/ButtonSelect";
import CssUnitWidget from "./CssUnitWidget";

/**
 * @description input for selecting object-fit css property for images
 * @author chills
 */

enum ObjectPositionY {
	TOP = "top",
	CENTER = "center",
	BOTTOM = "bottom"
}

enum ObjectPositionX {
	LEFT = "left",
	CENTER = "center",
	RIGHT = "right"
}

interface IObjectPosition {
	x: string;
	y: string;
}

const optionsX: IOption[] = [
	{icon: IconNames.ALIGNMENT_LEFT, value: ObjectPositionX.LEFT},
	{icon: IconNames.ALIGNMENT_VERTICAL_CENTER, value: ObjectPositionX.CENTER},
	{icon: IconNames.ALIGNMENT_RIGHT, value: ObjectPositionX.RIGHT}
];

const optionsY: IOption[] = [
	{icon: IconNames.ALIGNMENT_TOP, value: ObjectPositionY.TOP},
	{icon: IconNames.ALIGNMENT_HORIZONTAL_CENTER, value: ObjectPositionY.CENTER},
	{icon: IconNames.ALIGNMENT_BOTTOM, value: ObjectPositionY.BOTTOM}
];

class ObjectPositionWidget extends BaseWidget<IObjectPosition, string> {

	public render() {
		const { value, required, disabled, label } = this.props;

		const position = this.fromValue(value);

		return [
			(
				<FormGroup key="x" label="Horizontal Position">
					<ButtonSelect
						options={optionsX}
						value={position.x}
						onChange={(v) => this.onChange(position, v, "x")}
					/>
					<CssUnitWidget value={position.x} onChange={(v) => this.onChange(position, v, 'x')} />
				</FormGroup>
			),
			(
				<FormGroup key="y" label="Vertical Position">
					<ButtonSelect
						options={optionsY}
						value={position.y}
						onChange={(v) => this.onChange(position, v, "y")}
						readonly={false}
						autofocus={false}
					/>
					<CssUnitWidget value={position.y} onChange={(v) => this.onChange(position, v, 'y')} />
				</FormGroup>
			)
		];
	}

	@autobind
	protected fromValue(value: string): IObjectPosition {
		const v = iDef(value) ? value : "center center";
		const vSplit = v.split(' ');
		if (vSplit.length === 2) {
			return {
				x: vSplit[0],
				y: vSplit[1]
			};
		} else {
			return {
				x: ObjectPositionX.CENTER,
				y: ObjectPositionY.CENTER
			};
		}
	}

	@autobind
	protected toValue(position: IObjectPosition): string {
		return `${position.x} ${position.y}`;
	}

	@autobind
	protected onChange(position: IObjectPosition, value: string, part: string) {
		const newPosition: IObjectPosition = { ...position, [part]: value };
		this.props.onChange(this.toValue(newPosition));
	}
}

export default ObjectPositionWidget;



// WEBPACK FOOTER //
// ./src/common/form/widgets/ObjectPositionWidget.tsx